const QueryKeys = {
  FORGOT_PASSWORD: 'forgotPassword',
  RESET_PASSWORD: 'resetPassword',
  SIGN_UP: 'signUp',
  GET_PERSONAL_DETAILS: 'getPersonalDetails',
  GET_ACCOUNT_ME: 'getAccountMe',
  GET_PLAN: 'getPlan',
  PENDING_CONFIRMATION: 'pendingConfirmation',
  NEW_PENDING_CONFIRMATION: 'newPendingConfirmation',
  DELETE_PENDING_CONFIRMATION: 'deletePendingConfirmation',
  RESEND_PENDING_CONFIRMATION: 'resendPendingConfirmation',
  POST_PHONE_NUMBER: 'postPhoneNumber',
  CHANGE_PASSWORD: 'changePassword',
  DISABLE_ACCOUNT: 'disableAccount',
  PERSONAL_DETAILS: 'personalDetails',
  IDENTITY_EMAIL: 'identityEmail',
  PREFERENCES_KEYS: 'preferencesKeys',
  PREFERENCES_KEYS_GENERAL: 'preferencesKeysGeneral',
  PREFERENCES_KEYS_TEMPORAL: 'preferencesKeysTemporal',
  GET_PREFERENCES_GENERAL: 'getPreferencesGeneral',
  GET_PREFERENCES_TEMPORAL: 'getPreferencesTemporal',
  PUT_PREFERENCES_GENERAL: 'putPreferencesGeneral',
  PUT_PREFERENCES_TEMPORAL: 'putPreferencesTemporal',
  POST_FILE_UPLOAD: 'postFileUpload',
  PUT_PROFILE_PICTURE: 'putProfilePicture',
  GET_ORGS: 'getOrgs',
  GET_SINGLE_ORG: 'getSingleOrg',
  GET_ORG_PENDING_INVITATIONS: 'getOrgPendingInvitations',
  GET_ORG_USERS: 'getOrgUsers',
  INVITE_USERS_TO_ORG: 'inviteUsersToOrg',
  DELETE_USER_FROM_ORG: 'deleteUserFromOrg',
  UPDATE_ORG_USER: 'updateOrgUser',
  PASS_ORG_OWNERSHIP: 'passOrgOwnership',
  GET_COUNTRIES: 'getCountries',
  GET_AGE_RESTRICTION: 'getAgeRestriction',
  GET_GENDER_SPEC: 'getGenderSpec',
  GET_TEAMS: 'getTeams',
  GET_SEASONS_BY_TEAM: 'getSeasonsByTeam',
  GET_SEASON_TEAMS: 'getSeasonTeams',
  GET_GROUP_TEAMS: 'getGroupTeams',
  GET_SINGLE_TEAM: 'getSingleTeam',
  ADD_TEAM: 'addTeam',
  GET_COMPETITIONS: 'getCompetitions',
  GET_COMPETITION: 'getCompetition',
  GET_FEDERATION_STRUCTURE: 'getFederationStructure',
  GET_STAGES: 'getStages',
  GET_STAGES_WITH_STANDINGS: 'getStagesWithStandings',
  GET_GAMES_BY_CONTEXT: 'getGamesByContext',
  GET_PAIRED_COMPETITIONS: 'getPairedCompetitions',
  GET_PAIRED_CALENDAR_GAMES: 'getPairedCalendarGames',
  GET_STAGE: 'getStage',
  GET_GROUPS: 'getGroups',
  GET_GROUP: 'getGroup',
  GET_EVENT_TYPES: 'getEventTypes',
  GET_EVENTS: 'getEvents',
  GET_EVENT: 'getEvent',
  GET_ORG_PLAYERS: 'getOrgPlayers',
  GET_SEASON_TEAM_PLAYERS: 'getSeasonTeamPlayers',
  GET_POSITIONS: 'getPositions',
  GET_USER_PREFERENCES: 'getUserPreferences',
  GET_USER_EMAIL_PENDING_CONFIRMATIONS: 'getUserEmailPendingConfirmations',
  UPDATE_USER_LOGO: 'updateUserLogo',
  UPDATE_USER_PERSONAL_SETTINGS: 'updateUserPersonalSettings',
  UPDATE_USER_EMAIL_ADDRESS: 'updateUserEmailAddress',
  UPDATE_USER_PHONE_NUMBER: 'updateUserPhoneNumber',
  GET_COURTS: 'getCourts',
  GET_COURT: 'getCourt',
  GET_LIVESTREAM: 'getLivestream',
  GET_AD_VIDEO: 'getAdVideo',
  GET_AD_QUEUE: 'getAdQueue',
  GET_RUNNING_BROADCASTS_EVENTS: 'getRunningBroadcastsEvents',
  GET_RECENT_BROADCASTS: 'getRecentBroadcasts',
  GET_ORGS_AFTER_LOGIN: 'getOrgsAfterLogin',
  GET_TEAMS_AFTER_LOGIN: 'getTeamsAfterLogin',
  INVITATION_ACCEPT: 'invitationAccept',
  INVITATION_OWNERSHIP_ACCEPT: 'invitationOwnershipAccept',
  INVITATION_REJECT: 'invitationReject',
  DELETE_INVITATION: 'deleteInvitation',
  UPDATE_INVITATION: 'updateInvitation',
  GET_INVITATIONS: 'getUserInvitations',
  GET_INVITATIONS_NOTIFICATION: 'getUserInvitationsNotification',
  GET_LIVESTREAM_TYPES: 'getLivestreamTypes',
  GET_SCOREBOARD_SOURCES: 'getScoreboardSources',
  GET_ORG_SUB_STATUS: 'getOrgSubStatus',
  GET_ORG_CLUBS: 'getOrgClubs',
  GET_ORG_CLUB: 'getOrgClub',
  GET_CLUB_TEAMS: 'getClubTeams',
  GET_SUBSCRIPTION_OPTIONS: 'getSubscriptionOptions',
  VIVA_WEBHOOK: 'vivaWebhook',
  GET_SUBSCRIPTION_DETAILS: 'getSubscriptionDetails',
  GET_PAYMENTS: 'getPayments',
  GET_DOWNLOAD_RECORDING_URL: 'getDownloadRecordingUrl',
  GOOGLE_AUTHORIZATION_CALLBACK: 'googleAuthorizationCallback',
  GET_PRIVACY_STATUS: 'getPrivacyStatus',
  GET_SPECIFIC_LIVESTREAM: 'getSpecificLivestream',
  GET_PLAYER: 'getPlayer',
  GET_TEAM_STATS: 'getTeamStats',
  GET_PLAYER_STATS: 'getPlayerStats',
  GET_PLAYER_CAREER_STATS: 'getPlayerCareerStats',
  GET_PLAYER_SEASON_STATS: 'getPlayerSeasonStats',
  GET_GAME_STATS: 'getGameStats',
  GET_STATS_GAME_SETUP: 'getStatsGameSetup',
  GET_GAME_RESULT: 'getGameResult',
  GET_GAME_SUMMARY: 'getGameSummary',
  GET_TEAM_GAMES_STATS: 'getTeamGamesStats',
  GET_SOCIAL_ACCOUNT_STATUS: 'getSocialAccountStatus',
  GET_BILLING_SUMMARY: 'getBillingSummary',
  GET_CHANNEL: 'getChannel',
  GET_ORG_FANS_CHANNELS: 'getOrgFansChannels',
  GET_API_KEY: 'getApiKey',
  GET_OVERLAY_CARDS: 'getOverlayCards',
  GET_OVERLAY_STATUS: 'getOverlayStatus',
}

export default QueryKeys
